import React from 'react';

export type ConditionType = (() => boolean) | boolean;

export interface ConditionProps {
    when?: ConditionType;
}

export const checkCondition = (condition?: ConditionType): boolean => {
    if (!condition) {
        return false;
    }
    if (typeof condition === 'function') {
        return condition();
    }
    return condition;
};

export const Condition: React.FC<React.PropsWithChildren<ConditionProps>> = React.memo((props) => {
    const result = React.useMemo(() => checkCondition(props.when), [props.when]);
    if (!result) {
        return null;
    }
    return <>{props.children}</>;
});
Condition.displayName = 'Condition';
